import React from 'react'
import { useTranslation } from 'react-i18next'

import styles from './NoEarlierMessages.module.scss'

const NoEarlierMessages = () => {
  const { t } = useTranslation('Communications')

  return (
    <div className={styles.noEarlierMessages}>
      <span>{t('Communications:CHAT.NO_EARLIER_MESSAGES')}</span>
    </div>
  )
}

export default NoEarlierMessages
